module.exports.asyncGatewayList = [
    {
        gatewayType: 230,
        gatewayName: 'adyen',
        voidIsAsync: true,
        captureIsAsync: true,
        refundIsAsync: true,
        authOnlyIsAsync: true,
        saleIsAsync: true
    }
];

